import { render, staticRenderFns } from "./LeadsTablePage.vue?vue&type=template&id=ce68b56c&scoped=true&"
import script from "./LeadsTablePage.vue?vue&type=script&lang=js&"
export * from "./LeadsTablePage.vue?vue&type=script&lang=js&"
import style0 from "./LeadsTablePage.vue?vue&type=style&index=0&id=ce68b56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce68b56c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce68b56c')) {
      api.createRecord('ce68b56c', component.options)
    } else {
      api.reload('ce68b56c', component.options)
    }
    module.hot.accept("./LeadsTablePage.vue?vue&type=template&id=ce68b56c&scoped=true&", function () {
      api.rerender('ce68b56c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LeadsTablePage.vue"
export default component.exports